/**
 * 保険会社情報表示コンポーネント
 * モバイル時はアコーディオン形式で表示
 */
const DocumentInfoSection = ({
  documentInfo,
  isMobile,
  isDocInfoAccordionOpen,
  onToggleDocInfoAccordion,
}) => {
  {/* モバイル表示時のアコーディオン形式 */}
  if (isMobile) {
    return (
      <div className="doc-info-accordion-toolbar">
        <button
          className="doc-info-accordion-header-toolbar"
          onClick={onToggleDocInfoAccordion}
        >
          <span className={`doc-info-accordion-icon-toolbar ${isDocInfoAccordionOpen ? 'open' : ''}`}>
            ▼
          </span>
          <span className="doc-info-accordion-title-toolbar">
            {documentInfo.insuranceCompany}
          </span>
        </button>
        <div className={`doc-info-accordion-content-toolbar ${isDocInfoAccordionOpen ? 'open' : ''}`}>
          <div className="doc-info-items-toolbar"></div>
        </div>
      </div>
    );
  }

  {/* PC表示時のテーブル形式 */}
  return (
    <div className="doc-info-toolbar-row">
      <div className="doc-info-table-toolbar">
        <table className="doc-info-table">
          <thead>
            <tr>
              <th>
                {`保険会社名：`}
                <span style={{ fontWeight: 'normal' }}>
                  {`${documentInfo.insuranceCompany}`}
                </span>
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
};

export default DocumentInfoSection;
